import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDajwP7hD8PyvVfWxurDBDojDDTOMvSzyg",
  authDomain: "rm-express-f650f.firebaseapp.com",
  projectId: "rm-express-f650f",
  storageBucket: "rm-express-f650f.firebasestorage.app",
  messagingSenderId: "983381633812",
  appId: "1:983381633812:web:5ba447a41a34adfa3a3001"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };